var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert',{key:_vm.id || _vm.$vnode.key,attrs:{"portal":"alerts_add_product_page"},on:{"retry":function($event){return _vm.$emit('retry')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }